/**
 * SparkCounter — compact running SPARK count chip (tailored resumes +
 * mock interviews + applications). Refreshes when a resmo:spark event fires.
 */
import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { api } from "../lib/api";

export default function SparkCounter() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () => api.get("/sparks").then((r) => setData(r.data)).catch(() => {});
    load();
    const onSpark = () => setTimeout(load, 800);
    window.addEventListener("resmo:spark", onSpark);
    return () => window.removeEventListener("resmo:spark", onSpark);
  }, []);

  if (!data) return null;
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border-2"
         style={{ borderColor: "#0F1B2D", background: "#FFF7ED" }}
         title={`${data.tailored} tailored · ${data.interviews} mock interviews · ${data.applications} applications — every career begins with a SPARK.`}
         data-testid="spark-counter">
      <Flame size={14} style={{ color: "#FF6A00" }} />
      <span className="font-mono-rm text-xs font-bold" style={{ color: "#0F1B2D" }}>
        {data.total} SPARK{data.total === 1 ? "" : "S"}
      </span>
    </div>
  );
}
